

















import Vue from 'vue';
import _ from 'lodash';

import { NoticeDto, NoticeTypeEnum, NoticeViewDto } from '../@types/uzivatelske-notifikace';

export default Vue.extend({
	name: 'UzivatelskeNotifikace',
	props: {
		noticeList: { type: Array, default: (): [] => [] },
	},
	computed: {
		/*
		 * V DMS2 - co item v TextList to řádek - první řádek tučně.
		 * */
		notices(): object {
			return _.map(this.noticeList, (notice: NoticeDto) => ({
				NoticeType: notice.NoticeType,
				Title: _.head((notice.TextList)),
				Lines: _.tail(notice.TextList),
			}));
		},
	},
	methods: {
		hasTitle(notice: NoticeViewDto) {
			return notice.Title;
		},

		getIcon(notice: NoticeViewDto | NoticeDto) {
			switch (notice.NoticeType) {
				case NoticeTypeEnum.ERROR: return 'el-icon-error';
				case NoticeTypeEnum.INFO: return 'el-icon-info';
				case NoticeTypeEnum.SUCCESS: return 'el-icon-success';
				case NoticeTypeEnum.WARNING: return 'el-icon-warning';
				default: return '';
			}
		},
	},
});
